"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const damagedhair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-damagedhair` : '') + (description ? ` desc-damagedhair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-damagedhair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-damagedhair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.68 12.89c.4 0 .7.25.83.52.12.26.14.6-.04.9-.35.6-.5 1.68-.15 2.6.17.44.44.81.83 1.09.38.27.93.46 1.71.46a3 3 0 0 0 1.73-.47c.4-.27.67-.65.85-1.1.36-.92.24-2-.09-2.6a.95.95 0 0 1 0-.9.9.9 0 0 1 .81-.5h8.04a.75.75 0 0 1 0 1.5H16c.25.93.23 2.06-.17 3.05a3.87 3.87 0 0 1-1.39 1.79c-.68.47-1.54.73-2.58.73a4.4 4.4 0 0 1-2.57-.73 3.78 3.78 0 0 1-1.37-1.8 4.81 4.81 0 0 1-.1-3.04H.88a.75.75 0 0 1 0-1.5h7.8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.97 3.64c.1.02.17.11.2.17.03.08.05.16.05.22 0 .07-.02.13-.05.18L15.1 5.68a.8.8 0 0 1 .22-.08 1.61 1.61 0 0 1 .77.02l.06.04c.02.02.07.06.07.14 0 .04 0 .1-.02.15 0 .05-.02.11-.04.16a.3.3 0 0 1-.2.22A8.07 8.07 0 0 0 14 7.7c-.22.21-.38.57-.5 1-.11.38-.18.8-.22 1.14l.27-.23a.8.8 0 0 1 .17-.09c.04-.02.1-.03.15-.03l.06.02.06.02c.06.03.1.08.12.14.03.07.03.14.03.2a.84.84 0 0 1-.14.34 18.1 18.1 0 0 0-.77.96c-.15.25-.27.72-.34 1.65-.03.4.18.66.45 1.1.27.42.56.95.56 1.82 0 .87-.33 1.39-.8 1.68-.46.29-1.02.34-1.46.34-.97 0-1.75-.8-1.75-2.02a4.3 4.3 0 0 1 .73-2.29c.3-1.09.92-3.4 1.15-4.2.09-.3.06-.7 0-1.14l-.07-.62c-.02-.2-.03-.38-.02-.54l.03-.08a.24.24 0 0 1 .05-.07c.04-.05.1-.07.17-.06.09 0 .16.06.2.13l.02.07.21.8c.12-.28.3-.58.5-.88.34-.5.76-1.02 1.18-1.49a21.17 21.17 0 0 1 1.71-1.67.59.59 0 0 1 .09-.05l.06-.02h.06Z",
    fill: "#232323"
  }));
};
var _default = exports.default = damagedhair;